'use strict';

(function ($, KURODA_HD) {
	var a = 'is-active';
	var slideSpeed = '400';

	var spTabAccordion = function spTabAccordion() {
		if (KURODA_HD.va.window.width <= KURODA_HD.va.device.sp) {
			$('.mod-tab-head').on('click', function (e) {
				$(e.currentTarget).next('.mod-tab-body').stop().slideToggle(slideSpeed);
			});
		}
	};
	var setNewsTabSwitch = function setNewsTabSwitch() {
		var setKey = function setKey(_key) {
			if (_key === 'all') {
				$('.mod-newsList-item').each(function (idx, ele) {
					$(ele).removeClass('di_none');
				});
			} else {
				$('.mod-newsList-item').each(function (idx, ele) {
					if ($(ele).find('.mod-newsList-cat').hasClass(_key)) {
						$(ele).removeClass('di_none');
					} else {
						$(ele).addClass('di_none');
					}
				});
			}
		};
		if ($('.js-newsTab').length) {
			$('.js-newsTab').find('.mod-tab-item').on('click', function (e) {
				$('.js-newsTab').find('.mod-tab-item').each(function (idx, ele) {
					$(ele).removeClass(a);
				});
				$(e.currentTarget).addClass(a);

				var key = $(e.currentTarget).attr('data-target');
				setKey(key);
			});
			if (location.hash) {
				var key = location.hash.slice(1);
				$('.mod-tab-item[data-target="all"]').removeClass(a);
				$('.mod-tab-item[data-target="' + key + '"]').addClass(a);
				setKey(key);
			}
		}
	};
	var modalImg = function modalImg() {
		$('.mod-modal').on('click', function (e) {
			var HTML = '<div class="mod-modal-overlay">';
			HTML += '<div class="mod-modal-closeArea"></div>' + '<span class="mod-modal-closeBtn"><i class="icon icon-close"></i></span>' + ($(e.currentTarget).find('img').prop('outerHTML') + '</div>');
			$('body').append(HTML);

			var $overlay = $('.mod-modal-overlay');
			$overlay.addClass('is-active');
			setTimeout(function () {
				$overlay.addClass('is-visible');

				$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', function () {
					$overlay.removeClass('is-visible');
					setTimeout(function () {
						$overlay.removeClass('is-active');
						$overlay.remove();
					}, 400);
				});
			});
		});
	};
	var fileSize = function fileSize() {
		$('.js-fileSize').each(function (idx, ele) {
			$(ele).text(bytesToSize($(ele).text()));
		});

		function bytesToSize(bytes) {
			var sizes = ['Bytes', 'KB', 'MB', 'GB'];
			if (bytes === 0) return '0 Byte';
			var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
			var convSize = Math.floor(bytes / Math.pow(1024, i) * Math.pow(10, 1)) / Math.pow(10, 1);
			// KBのとき、小数点切り捨て
			if (i === 1) convSize = Math.floor(convSize);
			return convSize + sizes[i];
		}
	};
	var mainVisual = function mainVisual() {
		$('.idx-mainVis-slider').slick({
			arrows: false,
			autoplay: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplaySpeed: 5000,
			loop: true,
			infinite: true,
			dots: true
		});
	};

	spTabAccordion();
	setNewsTabSwitch();
	modalImg();
	fileSize();
	mainVisual();
})(window.jQuery, window.KURODA_HD);